import {Navigate, createBrowserRouter} from "react-router-dom";
import Login from "./pages/auth/login";
import RecuperacaoSenha from "./pages/auth/recuperacao-senha";
import AtualizarSenha from "./pages/auth/atualizar-senha";
import Dashboard from "./pages/dashboard";
import {ProtectedRoute} from "./components/protectedRoute";
import ListUser from "./pages/user/list";
import CreateUser from "./pages/user/create";
import UpdateUser from "./pages/user/update";
import ListEnvironment from "./pages/environments/list";
import CreateEnvironment from "./pages/environments/create";
import UpdateEnvironment from "./pages/environments/update";


export const routes = createBrowserRouter([
  {
    path: "/login",
    element: <Login/>,
  },
  {
    path: "/recuperar-senha",
    element: <RecuperacaoSenha/>,
  },
  {
    path: "/atualizar-senha",
    element: <AtualizarSenha/>,
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />
  },
  {
    element: <ProtectedRoute/>,
    children: [
      {
        path: "dashboard",
        element: <Dashboard/>,
      },
      {
        path: "usuarios/listar",
        element: <ListUser/>,
      },
      {
        path: "usuarios/cadastrar",
        element: <CreateUser/>,
      },
      {
        path: "usuarios/editar/:id",
        element: <UpdateUser/>,
      },
      {
        path: "environments/listar",
        element: <ListEnvironment/>,
      },
      {
        path: "environments/cadastrar",
        element: <CreateEnvironment/>,
      },
      {
        path: "environments/editar/:id",
        element: <UpdateEnvironment/>,
      },
    ]
  },
]);

